"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rand_1 = require("./rand");
var apply_1 = require("./apply");
var process_1 = require("./process");
var simulate_1 = require("./simulate");
var Mistakes = __importStar(require("./mistakes"));
exports.DEFAULT_MISTAKES = [
    { apply: Mistakes.miss, probability: 0.033 },
    { apply: Mistakes.omit, probability: 0.033 },
    { apply: Mistakes.duplicate, probability: 0.001 },
    { apply: Mistakes.toggleCase, probability: 0.033 },
    { apply: Mistakes.capitalize, probability: 0.033 },
    { apply: Mistakes.repeat, probability: 0.5 },
    { apply: Mistakes.substitute, probability: 0.5 }
];
var Humanized = /** @class */ (function () {
    function Humanized(stream) {
        this.stream = stream;
    }
    Humanized.prototype.toString = function () {
        return exports.toString(this.stream);
    };
    return Humanized;
}());
function humanize(string, options) {
    if (options === void 0) { options = {}; }
    var seed = options.seed, _a = options.mistakes, mistakes = _a === void 0 ? exports.DEFAULT_MISTAKES : _a;
    var stream = process_1.process(string);
    if (seed)
        rand_1.initRand(seed);
    return new Humanized(mistakes.reduce(function (stream, mistake) {
        return stream.map(function (word) {
            return apply_1.apply(mistake.apply, word, mistake.probability).map(function (char) {
                return apply_1.apply(mistake.apply, char, mistake.probability);
            });
        });
    }, stream));
}
exports.humanize = humanize;
exports.toString = function (stream) {
    if (stream[0].constructor === Array) {
        return process_1.toString(stream);
    }
    return simulate_1.toString(stream);
};
